import { appConfig } from "src/config/default";
import { POIZON_API_DOCS_LINK } from "src/constants/links";
import { useTranslate } from "src/i18n";
import { ILink } from "src/types";

import { IContact } from "../types/contact";

interface IFooterLinksProps {
  links: ILink[];
  contacts: IContact[];
  titles: Record<"navigation" | "contacts" | "social" | "privacy", string>;
}

export const useFooterData = (): IFooterLinksProps => {
  const { t } = useTranslate();

  const generalQuestionsLabel = t(
    "footer.contacts.for_general_questions",
    "По общим вопросам",
  );

  const generalContact: IContact = {
    title: appConfig.contactEmail,
    subtitle: generalQuestionsLabel,
    href: `mailto:${appConfig.contactEmail}`,
  };

  const contacts: IContact[] = [
    generalContact,
    {
      title: "api@poparce.ru",
      subtitle: t("footer.contacts.api_department", "Отдел по работе с API"),
      href: "mailto:api@poparce.ru",
    },
  ];

  const links: ILink[] = [
    {
      path: "/lk",
      name: t("footer.links.dashboard", "Консоль"),
    },
    {
      path: "/#advantages",
      name: t("footer.links.advantages", "Преимущества"),
    },
    {
      path: "/#about",
      name: t("footer.links.about_us", "О нас"),
    },
    {
      path: "/#reviews",
      name: t("footer.links.reviews", "Отзывы"),
    },
    {
      path: "/#links",
      name: t("footer.links.contacts", "Контакты"),
    },
    {
      path: POIZON_API_DOCS_LINK,
      name: t("footer.links.faq", "ЧаВо"),
    },
  ];

  const titles = {
    navigation: t("footer.title.navigation", "Навигация"),
    contacts: t("footer.title.contacts", "Контакты"),
    privacy: t("footer.title.privacy", "Правовая информация"),
    social: t("footer.title.social", "Социальные сети"),
  };

  return { contacts, links, titles };
};
